import type {
  FilterOptionValue,
  SelectedFilterValues,
} from '@latitude/filter-toolbar';

export const extractSelectedIds = (
  filterState: SelectedFilterValues,
  filterId: string,
): string[] => {
  const value = filterState[filterId];
  if (!value || typeof value !== 'object') {
    return [];
  }
  const optionValues = value as FilterOptionValue;
  return Object.keys(optionValues).filter((id) => optionValues[id]);
};
